import { fetchEntities } from "./entities";
import { createEntityWithDefaults } from "./entities";

export function createContactWithDefaults(entity = {}) {
  return function(dispatch, getState) {
    return  dispatch(createEntityWithDefaults('contact', entity, false))
  }
}

export function fetchContact(id) {
  return function(dispatch, getState) {
    dispatch(fetchEntities('contacts', { name: 'contact', filter: { id: id }, page: 1 }))
  }
}
